import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

// Opens its element as a Bootstrap modal as soon as it connects, so a
// server-rendered modal pops without a trigger button. Backdrop/ESC behaviour
// is left to the element's data-bs-* attributes. Importing Modal directly (vs
// reading window.bootstrap) avoids any dependency on global-assignment order.
export default class extends Controller {
  connect() {
    this.modal = Modal.getOrCreateInstance(this.element)
    // Dispose only after the hide transition finishes, so Bootstrap can tear
    // down the backdrop and body.modal-open state cleanly.
    this.teardown = this.teardown.bind(this)
    this.element.addEventListener('hidden.bs.modal', this.teardown)
    this.modal.show()
  }

  disconnect() {
    if (!this.modal) return

    // If still visible, let hide() run its transition — teardown fires on the
    // hidden.bs.modal event. If already hidden, tear down now.
    if (this.element.classList.contains('show')) {
      this.modal.hide()
    } else {
      this.teardown()
    }
  }

  teardown() {
    this.element.removeEventListener('hidden.bs.modal', this.teardown)
    if (this.modal) {
      this.modal.dispose()
      this.modal = null
    }
  }
}
